/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import { connect } from "react-redux";
import SearchIcon from "@material-ui/icons/Search";
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
  CircularProgress,
  makeStyles,
  OutlinedInput,
  Button,
  Chip,
  Badge,
  useMediaQuery,
  Grid,
} from "@material-ui/core";
import moment from "moment-jalaali";
import { DatePicker } from "@material-ui/pickers";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import _ from "lodash";
import JalaliUtils from "@date-io/jalaali";
import LocalContext from "../../../../Context/LocalContetxt";
import actions from "../../../../redux/actions";

const status = [
  {
    id: 3,
    title: "زمانبندی شده",
  },
  {
    id: 2,
    title: "زمانبندی نشده",
  },
  {
    id: 4,
    title: "درحال برگزاری",
  },
  {
    id: 5,
    title: "برگزار شده",
  },
  {
    id: 6,
    title: "تایید شده",
  },
  {
    id: 11,
    title: "تعلیق شده",
  },
  {
    id: 7,
    title: "لغو شده",
  },
];

const useStyle = makeStyles({
  container: {
    display: "flex",
    alignItems: "center",
  },
  container_2: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    "@media (max-width: 480px)": {
      flexDirection: "row",
      justifyContent: "center",
    },
  },
  searchInput: {
    fontSize: ".9rem",
  },
  "@media (max-width: 480px)": {
    container: {
      flexDirection: "column",
    },
  },
  buttonContainer: {
    "@media (max-width: 620px)": {
      marginTop: 10,
    },
    display: "flex",
    justifyContent: "center",
  },
});

const Filter = (props) => {
  const {
    loading,
    activeTab,
    setTab,
    setFromDate,
    setToDate,
    fromDate,
    toDate,
    setSearch,
    resetDateFilters,
    searchString,
    resetSessions,
    fetchSessions,
  } = props;
  const classes = useStyle();
  const lang = useContext(LocalContext).lang;
  const config = useContext(LocalContext).config;
  const smMatch = useMediaQuery("(min-width:778px)");
  const xsMatch = useMediaQuery("(min-width:420px)");

  const filterTags = makeChipsData(
    [searchString, activeTab, [fromDate, toDate]],
    { resetDateFilters, setTab, setSearch }
  );

  const changeTab = (event, tab) => {
    setTab(event.target.value);
  };

  useEffect(() => {
    let fromDateStart = moment(fromDate).startOf("day").toISOString();
    let toDateEnd = moment(toDate).endOf("day").toISOString();

    const hasUtterDate = [fromDate, toDate].every(
      (item) => _.isDate(item) || _.isEmpty(item)
    );
    if (hasUtterDate && fromDate <= toDate) {
      resetSessions();
      fetchSessions(config.role, {
        Page: 0,
        PageSize: 10,
        status: activeTab,
        Fullname: searchString,
        ...(fromDate && {
          DateTimeFrom: new Date(fromDateStart),
        }),
        ...(toDate && {
          DateTimeTo: new Date(toDateEnd),
        }),
      });
    }
  }, [fromDate, toDate]);

  if (!setTab) return null;

  return (
    <Grid container width="100%">
      <Grid xs={12} container spacing={3} style={{ margin: "10px 0 0" }}>
        <Grid
          sm={6}
          xs={12}
          md={3}
          lg={3}
          item
          display="flex"
          mb="15px"
          alignItems="center"
        >
          <FormControl size="small" style={{ width: "100%" }}>
            <OutlinedInput
              startAdornment={
                loading ? (
                  <InputAdornment position="start">
                    <CircularProgress size="1.2rem" />
                  </InputAdornment>
                ) : (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                )
              }
              className={classes.searchInput}
              disabled={false}
              name="جستوجو"
              lable="جستوجو"
              autocomplete="جستوجو"
              value={searchString}
              onChange={({ target: { value } }) => setSearch(value)}
              lang={lang}
              tabIndex={3}
              placeholder="جستوجو بر اساس نام"
            />
          </FormControl>
        </Grid>
        <Grid
          md={3}
          lg={3}
          sm={6}
          xs={12}
          item
          display="flex"
          mb="15px"
          mx={xsMatch ? "10px" : "0"}
          alignItems="center"
        >
          <FormControl
            style={{ width: "100%" }}
            size="small"
            variant="outlined"
            className="fullwidth_container_dropdown"
          >
            <InputLabel htmlFor="outlined-age-native-simple">
              فیلتر کلاس ها
            </InputLabel>
            <Select
              MenuProps={{
                disableScrollLock: true,
              }}
              className="fullwidth_container_dropdown"
              value={activeTab}
              onChange={changeTab}
              label="فیلتر کلاس ها"
              inputProps={{
                name: "age",
                id: "outlined-age-native-simple",
              }}
              dir="rtl"
            >
              <MenuItem className="rtl-text" aria-label="None" value={0}>
                همه
              </MenuItem>
              {status.map((item) => (
                <MenuItem className="rtl-text" value={item.id} key={item.id}>
                  {item.title}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid
          md={6}
          lg={6}
          sm={12}
          xs={12}
          item
          display="flex"
          mb="15px"
          alignItems="center"
          mx={smMatch ? "10px" : "0"}
          {...(smMatch && {
            borderLeft: "1px solid #cccccc",
            px: "15px",
          })}
        >
          <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <DatePicker
                  size="small"
                  PopoverProps={{
                    disableScrollLock: true,
                  }}
                  autoOk
                  ampm={false}
                  variant="inline"
                  inputVariant="outlined"
                  label="از تاریخ"
                  fullWidth
                  format="yyyy/MM/dd"
                  labelFunc={(date) =>
                    date ? date.format("jYYYY/jMM/jDD") : ""
                  }
                  emptyLabel="از تاریخ"
                  value={fromDate}
                  onChange={setFromDate}
                />
              </Grid>
              <Grid item xs={6}>
                <DatePicker
                  autoOk
                  size="small"
                  PopoverProps={{
                    disableScrollLock: true,
                  }}
                  error={fromDate > toDate}
                  ampm={false}
                  variant="inline"
                  inputVariant="outlined"
                  label="تا تاریخ"
                  fullWidth
                  format="yyyy/MM/dd"
                  labelFunc={(date) =>
                    date ? date.format("jYYYY/jMM/jDD") : ""
                  }
                  emptyLabel="تا تاریخ"
                  value={toDate}
                  onChange={setToDate}
                />
              </Grid>
            </Grid>
          </MuiPickersUtilsProvider>
        </Grid>
      </Grid>

      <Box display="flex" alignItems="center" mt={"10px"}>
        {filterTags
          .filter((item) => item.show)
          .map((item, index) => (
            <Box ml={index > 0 ? "10px" : 0}>
              <Chip label={item.text} onDelete={item.onClick} />
            </Box>
          ))}
      </Box>
    </Grid>
  );
};

const mapStateToProps = (state) => ({
  loading: state.dashboard.sessions.fetching,
  activeTab: state.dashboard.status.activeTab,
  fromDate: state.dashboard.sessionsFilter.from_date,
  toDate: state.dashboard.sessionsFilter.to_date,
  searchString: state.dashboard.search.string,
});

const mapDispatchToProps = (dispatch) => ({
  setTab: (tab) => dispatch(actions.dashboard.status.setTab(tab)),
  setFromDate: (date) =>
    dispatch(actions.dashboard.sessionsFilter.setFrom(date)),
  setToDate: (date) => dispatch(actions.dashboard.sessionsFilter.setTo(date)),
  resetDateFilters: () => dispatch(actions.dashboard.sessionsFilter.reset()),
  setSearch: (string) => dispatch(actions.dashboard.search.setSearch(string)),
  fetchSessions: (role, params) =>
    dispatch(actions.dashboard.sessions.fetch(role, params)),
  resetSessions: () => dispatch(actions.dashboard.sessions.reset()),
});

const makeDateFormat = (item) => {
  if (typeof item === "object") {
    return moment(item).format("jYYYY/jMM/jDD");
  }

  return "-";
};

const makeChipsData = (array, methods) => {
  const { resetDateFilters, setTab, setSearch } = methods;
  return array.map((item, index) => {
    switch (true) {
      case _.isNumber(item):
        return {
          show: item > 0,
          text: status.find((x) => Number(item) === x.id)?.title || 0,
          onClick: () => setTab(0),
        };
      case _.isArray(item):
        return {
          show: _.isDate(item[0]) && _.isDate(item[1]),
          text: `از ${makeDateFormat(item[0])} تا ${makeDateFormat(item[1])}`,
          onClick: () => {
            resetDateFilters();
          },
        };

      case _.isString(item):
        return {
          show: !_.isEmpty(item),
          text: item,
          onClick: () => setSearch(""),
        };
      default:
        return {
          show: false,
          text: item,
        };
    }
  });
};

export default connect(mapStateToProps, mapDispatchToProps)(Filter);
